import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';

@Component({
  selector: 'app-wild-card-table',
  templateUrl: './wild-card-table.component.html',
  styleUrls: ['./wild-card-table.component.sass']
})
export class WildCardTableComponent extends BaseListDirective {

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('key_', 'FORM.NAME', 300, { frozen: true }),
    new PrimeNGTableColumn('type_', 'FORM.TYPE', 300, { frozen: true }),
    new PrimeNGTableColumn('content', 'FORM.CONTENT', 300, { frozen: true })
  ];

  override title = 'MENU.TEMPLATES';
  override filterableFields = []
  override keys = {
    primary_key: 'wildcard_id',
    label: 'name_'
  }
  override filename = 'MENU.TEMPLATES';

  override exportValue(column, row): string {
    switch (column.field) {
      case 'type_':
        return this.utils.translate.instant('MENU.' + row.type_);
      default:
        return super.exportValue(column, row);
    }
  }

  override getList(): void {
    this.query(this.data.core.wildcards()).subscribe()
  }

  override handleRows(data: any): void {
    console.log(data);
    super.handleRows(data);
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.wildcardDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }
}

